// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".watch-on-lumen5--o43C_{position:absolute;top:12px;right:12px;z-index:10;display:inline-flex;align-items:center;gap:8px;padding:6px 14px 6px 10px;background:rgba(0,0,0,.6);color:#fff;font-size:13px;text-decoration:none;border-radius:999px;-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}.watch-on-lumen5--o43C_ img{display:block;height:18px;width:auto}.watch-on-lumen5--o43C_:hover{background:rgba(0,0,0,.8);color:#fff;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"watch-on-lumen5": "watch-on-lumen5--o43C_"
};
export default ___CSS_LOADER_EXPORT___;
